export enum FlagReason {
  Offensive = 'offensive',
  Spam = 'spam',
  Incorrect = 'incorrect',
  Other = 'other',
}

export interface FlagContentParams {
  type: 'flagContent';
  contentType: string;
  contentId: string;
  contentName: string;
  reason: FlagReason;
  description?: string;
  reporterName: string;
  replyToEmail: string;
  commonEventParams: any;
}
